export function afterInteraction(timeoutMs = 8000): Promise<void> {
  return new Promise((resolve) => {
    const done = () => {
      clearTimeout(timer);
      interactionEvents.forEach(e => globalThis.removeEventListener(e, done));
      resolve();
    };

    const timer = setTimeout(done, timeoutMs);
    const interactionEvents = ['pointerdown', 'scroll', 'keydown', 'touchstart'];
    interactionEvents.forEach(e => globalThis.addEventListener(e, done, { once: true, passive: true }));
  });
}
